import { LOCALES } from "../../../../utlis/locale";

export const reportText = (locale, key) =>
  LOCALES[locale]?.mobilityRender?.[key] ||
  LOCALES.en.mobilityRender[key] ||
  key;

// Print the displayed server revision after its fonts and media settle.
export async function printReport(root, isCurrent = () => true) {
  if (document.fonts?.ready) await document.fonts.ready;
  await Promise.all(
    Array.from(root?.querySelectorAll("img") || []).map((image) => {
      if (image.complete) return Promise.resolve();
      return new Promise((resolve) => {
        image.addEventListener("load", resolve, { once: true });
        image.addEventListener("error", resolve, { once: true });
        setTimeout(resolve, 10000);
      });
    }),
  );
  await new Promise((resolve) =>
    requestAnimationFrame(() => requestAnimationFrame(resolve)),
  );
  if (isCurrent()) window.print();
}
export const reportErrorKey = (error) => {
  if (error?.code === "MobilityReportProcessing") return "processing";
  const status = error?.response?.status || error?.status;
  if (status === 404) return "not_found";
  if (status === 410) return "expired";
  if (
    error?.name === "UnsupportedMobilityReport" ||
    ["UNSUPPORTED_REPORT", "UnsupportedMobilityReport"].includes(error?.code)
  )
    return "unsupported";
  return "error";
};

// The API error envelope carries localized validation copy. Never expose a
// transport Error.message, stack, or a raw backend object to the user.
export const reportEditError = (error, t) => {
  if (error?.code === "MobilityReportProcessing") return t("processing");
  const envelope = error?.response?.data?.error;
  const fields = envelope?.field_errors;
  const messages = [];
  if (typeof envelope?.message === "string") messages.push(envelope.message);
  const add = (value) => {
    if (typeof value === "string") messages.push(value);
    else if (value && typeof value.message === "string")
      messages.push(value.message);
  };
  if (Array.isArray(fields)) fields.forEach(add);
  else if (fields && typeof fields === "object")
    Object.values(fields).forEach((value) =>
      Array.isArray(value) ? value.forEach(add) : add(value),
    );
  return messages.filter(Boolean).join(" ") || t("saveFailed");
};
